import React from 'react'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'

class Demographics extends React.Component {
  render() {
    const { details, hotload } = this.props

    let divStyle = {
      backgroundImage: `url(${details.headshot})`
    }

    return (
      <div className="demographics-content module-content mobile-padding">
        {hotload ? (
          <div className="demoGroup">
            {this.props.isMobile && <h2>Demographics</h2>}
            <div className="sub headshot">
              <div className="image" style={divStyle} />
            </div>

            <div className="demographics-container">
              <div className="demographics-name">{details.full_name.value}</div>
              <div className="details-container">
                <div className="sub age">
                  <div className="sub-child">
                    <div className="flex-child">
                      <span>Date of Birth</span>
                      <strong>
                        {!details.birth_date.__ok ? (
                          <div className="no-report-data">{`N/A`}</div>
                        ) : (
                          moment(details.birth_date.value).format('M/D/YYYY')
                        )}
                      </strong>
                    </div>
                  </div>
                  <div className="sub-child">
                    <div className="flex-child">
                      <span>Age</span>
                      <strong>
                        {!details.age.__ok ? (
                          <div className="no-report-data">{`N/A`}</div>
                        ) : (
                          details.age.value
                        )}
                      </strong>
                    </div>
                  </div>
                  <div className="sub-child">
                    <div className="flex-child">
                      <span>Gender</span>
                      <strong>
                        {!details.gender.__ok ? (
                          <div className="no-report-data">{`N/A`}</div>
                        ) : (
                          details.gender.value
                        )}
                      </strong>
                    </div>
                  </div>
                </div>
                <div className="sub gender">
                  <div className="sub-child">
                    <div className="flex-child">
                      <span>Handedness</span>
                      <strong>
                        {!details.dexterity.__ok ? (
                          <div className="no-report-data">{`N/A`}</div>
                        ) : (
                          details.dexterity.value
                        )}
                      </strong>
                    </div>
                  </div>
                  <div className="sub-child">
                    <div className="flex-child">
                      <span>Race</span>
                      <strong>
                        {!details.race.__ok ? (
                          <div className="no-report-data">{`N/A`}</div>
                        ) : (
                          details.race.value
                        )}
                      </strong>
                    </div>
                  </div>
                  <div className="sub-child">
                    <div className="flex-child">
                      <span>Ethnicity</span>
                      <strong>
                        {!details.ethnicity.__ok ? (
                          <div className="no-report-data">{`N/A`}</div>
                        ) : (
                          details.ethnicity.value
                        )}
                      </strong>
                    </div>
                  </div>
                </div>

                {/*} <div className="sub race">

            </div>
            */}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

Demographics.propTypes = {
  details: PropTypes.object.isRequired
}

export default Demographics
